module.exports = __webpack_public_path__ + "img/jp-login.f3123e12.png";